import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';
import { languageSet } from '../language';
import { LandingpageService } from '../services/landingpage.service';

@Component({
    selector: 'app-show-news',
    templateUrl: './show-news.component.html',
    styleUrls: ['./show-news.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ShowNewsComponent implements OnInit {

  news: any;
  myLanguage = languageSet.de;
  browserLocale = window.navigator.language;
  userData: any;
  error = '';
  constructor(
    private route: ActivatedRoute,
    public landingpageService: LandingpageService,
    public oidcSecurityService: OidcSecurityService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    const newsId = routeParams.get('newsId');
    if (newsId !== null) {
      document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'visible';

      this.oidcSecurityService.getUserData().subscribe({
        next: (userData) => {
          this.userData = userData;
          if (this.userData.preferredLanguage && this.userData.preferredLanguage !== '' && this.userData.preferredLanguage !== 'german') {
            switch (this.userData.preferredLanguage) {
              case 'hungarian':
                this.myLanguage = languageSet.hu;
                this.browserLocale = 'hu';
                break;

              case 'austrian':
                this.myLanguage = languageSet.at;
                this.browserLocale = 'de';
                break;
            }
          } else {
            if (!this.userData.nickname.includes('@')) {
              switch (this.userData.nickname.indexOf(0)) {
                case 'H':
                  this.myLanguage = languageSet.hu;
                  this.browserLocale = 'hu';
                  break;

                case 'U':
                  this.myLanguage = languageSet.hu;
                  this.browserLocale = 'hu';
                  break;
              }
            }
          }

          this.landingpageService.getNewsById(newsId).subscribe({
            next: (news) => {
              this.news = news;
              // hide spinner
              document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';
            },
            error: (err) => {
              // hide spinner
              document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';

              if (err.error.error && err.error.error === 'Forbidden') {
                this.error = this.myLanguage.news_read_missing_permissions;
              } else {
                this.error = this.myLanguage.generic_loading_error;
              }
            }
          });
        },
        error: (err) => {
          console.error(err);
        }
      })
    }
  }

  renderBusiness(business: string[]): string {
    return business.join(', ')
      .replace('gisaInvestAdvisor', 'Vermögensberater')
      .replace('gisaInsuranceAgent', 'Versicherungsagent / §34d')
      .replace('gisaTipster', 'Tippgeber')
      .replace('gisa34f', '§34f')
      .replace('gisa34i', '§34i')
      .replace('akquisitionsvertragVom', 'Akq.-Vertrag');
  }


}
